import { SxProps, Theme } from "@mui/material";
import colorsConstants from "src/app/constants/colors.constants";

const styles = {
  parent: {
    backgroundColor: colorsConstants.mainContentBackgroundColor,
    flex: 1,
    display: "flex",
    height: "100vh",
  },
  drawerAwareContainer: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    padding: "24px",
  },
  titleGrid: {
    display: "flex",
    alignItems: "center",
    gap: 2,
    width: "90%",
    positionAnchor: "revert",
  },
  titleText: {
    color: colorsConstants.primaryText,
    fontSize: 24,
    textAlign: "center",
    flex: 1,
    marginLeft: "24px",
  },
  selectorContainer: {
    width: "100%",
  },
  selectorPaper: {
    p: 2,
    borderRadius: 2,
    border: "1px solid rgba(0, 0, 0, 0.08)",
    backgroundColor: colorsConstants.drawerListItemContainerSelected,
    boxShadow: "none",
  },
  tabsContainer: {
    borderRadius: "10px",
    border: "1px solid rgba(0, 0, 0, 0.1)",
    overflow: "hidden",
    backgroundColor: "transparent",
    boxShadow: "none",
  },
  selectedTab: {
    p: { xs: 2, sm: 3 },
  },
  selectedTabText: {
    color: colorsConstants.primaryText,
    fontWeight: 700,
    mb: 2,
  },
  searchingLoader: {
    display: "flex",
    justifyContent: "center",
    py: 4,
  },
  noItemsText: {
    color: colorsConstants.primaryText,
    opacity: 0.7,
  },
  eventCard: {
    p: 0,
    borderRadius: 2,
    border: "1px solid rgba(0, 0, 0, 0.08)",
    backgroundColor: colorsConstants.drawerListItemContainerSelected,
    boxShadow: "none",
    overflow: "hidden",
    cursor: "pointer",
    transition: "transform 0.12s, box-shadow 0.15s",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 6px 22px rgba(0,0,0,0.10)",
    },
    display: "flex",
    flexDirection: "column",
  },
  eventCardBanner: {
    width: "100%",
    height: 140,
    objectFit: "cover",
    backgroundColor: "rgba(0,0,0,0.06)",
    display: "block",
  },
  eventCardBannerFallback: {
    width: "100%",
    height: 140,
    backgroundColor: "rgba(25,118,210,0.08)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "rgba(25,118,210,0.6)",
    fontSize: 48,
  },
  eventCardBody: {
    p: 2,
    display: "flex",
    flexDirection: "column",
    flex: 1,
  },
  eventCardTitleRow: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: 1,
    mb: 0.5,
    flexWrap: "wrap",
  },
  eventCardTitle: {
    color: colorsConstants.primaryText,
    fontWeight: 700,
    fontSize: 16,
    flex: 1,
    minWidth: 0,
    wordBreak: "break-word",
  },
  eventCardChipsRow: {
    display: "flex",
    gap: 0.5,
    flexWrap: "wrap",
    mb: 1,
  },
  eventCardMeta: {
    color: colorsConstants.primaryText,
    opacity: 0.75,
    fontSize: 13,
    mb: 0.25,
  },
  eventCardDescription: {
    color: colorsConstants.primaryText,
    fontSize: 13,
    mt: 0.5,
    mb: 1,
    overflow: "hidden",
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    opacity: 0.85,
  },
  eventCardActionsRow: {
    display: "flex",
    gap: 1,
    flexWrap: "wrap",
    mt: "auto",
    pt: 1,
  },
  eventCardCreator: {
    color: colorsConstants.primaryText,
    fontSize: 12,
    opacity: 0.6,
    mt: 0.5,
  },
  composeFormContainer: {
    p: 2,
    borderRadius: 2,
    border: "1px solid rgba(0, 0, 0, 0.08)",
    backgroundColor: colorsConstants.drawerListItemContainerSelected,
    boxShadow: "none",
  },
  composeFormField: {
    mb: 2,
  },
  bannerUploadBox: {
    width: "100%",
    minHeight: 160,
    borderRadius: 2,
    border: "2px dashed rgba(0, 0, 0, 0.15)",
    backgroundColor: "rgba(0, 0, 0, 0.02)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    transition: "border-color 0.15s, background-color 0.15s",
    "&:hover": {
      borderColor: "rgba(25,118,210,0.5)",
      backgroundColor: "rgba(25,118,210,0.04)",
    },
    overflow: "hidden",
    position: "relative",
    mb: 2,
  },
  bannerPreview: {
    width: "100%",
    height: 220,
    objectFit: "cover",
    display: "block",
  },
  bannerPreviewActions: {
    position: "absolute",
    top: 8,
    right: 8,
    display: "flex",
    gap: 0.5,
  },
  paidSectionBox: {
    p: 2,
    borderRadius: 2,
    border: "1px solid rgba(255, 152, 0, 0.25)",
    backgroundColor: "rgba(255, 152, 0, 0.04)",
    mb: 2,
  },
  publicSectionBox: {
    p: 2,
    borderRadius: 2,
    border: "1px solid rgba(76, 175, 80, 0.25)",
    backgroundColor: "rgba(76, 175, 80, 0.04)",
    mb: 2,
  },
  submitButton: {
    mt: 1,
  },
  requestActionsContainer: {
    display: "flex",
    gap: 1,
    flexWrap: "wrap",
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
